import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { Button, Chip, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Image } from 'cloudinary-react';
import { useDispatch } from 'react-redux';
import { addToCart } from '../../features/slices/cartSlice';
import { useGetCartQuery, useGetUserFavoritesQuery, useUpdateCartMutation, useUpdateFavoriteMutation } from '../../features/fullApi'
import { useNavigate } from 'react-router-dom';
import { AddShoppingCart } from '@mui/icons-material';
import { toast } from 'react-hot-toast';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { addToFavorite, removeFromFavorite } from '../../features/slices/favoriteSlice';



const Info = styled.div`
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease;
  cursor: pointer;
`;

const Container = styled.div`
  flex: 1;
  margin: 5px;
  min-width: 280px;
  height: 300px;
  align-items: center;
  justify-content: center;
  background-color: #f5fbfd;
  position: relative;
  &:hover ${Info}{
    opacity: 1;
  }
`;

const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 350px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 0 1rem;
  margin: 2rem 0;
`;

const TabletContainer = styled.div`
  display: flex;
  flex: 1;
  margin: 5px;
  width: 450px;
  height: 250px;
  align-items: center;
  justify-content: center;
  background-color: #f5fbfd;
  position: relative;s23
  &:hover ${Info}{
    opacity: 1;
  }
`;

const Icon = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  transition: all 0.5s ease;
  &:hover {
    background-color: #e9f5f5;
    transform: scale(1.1);
  }
`;


const PopularProduct = ({product}) => {






  const navigate = useNavigate()

  const user = JSON.parse(localStorage.getItem('user'))
  const dispatch = useDispatch()

  const [updateCart] = useUpdateCartMutation()

  const {data: cart, error: cartError, isLoading: cartIsLoading} = useGetCartQuery(user?._id);

  const theme = useTheme()

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));

  const [updateFavorite] = useUpdateFavoriteMutation()

  const [checked, setChecked] = useState(false)
  const [red, setRed] = useState(false)

  const {data: favorite, error: favoriteError, isLoading: favoriteIsLoading} = useGetUserFavoritesQuery(user?._id);
  useEffect(() => {
    if(!favoriteIsLoading) {
      console.log("favorite is", favorite)
      favorite?.products.map(favoriteProd => {
        console.log("favoriteProd", favoriteProd)
        console.log("product", product)
        if(favoriteProd.productId === product._id) {
          setRed(true)
        }
    })
    setChecked(true)
    }
  }, [favoriteIsLoading])

  const handleAddToFavorites = (productz) => {
    if(user?.accessToken && favorite?._id) {
      console.log("product is", productz)
        setRed(true)
        let newProducts = []
        const currentProducts = JSON.parse(localStorage.getItem("favoriteItems"))
        console.log("CURRENT PRODUCTS$$$", currentProducts)
        currentProducts?.map(product => {
          if(product._id === productz._id) {
            dispatch(removeFromFavorite(productz))
            setRed(false)
          } else {
            newProducts.push({productId: product._id})
          }
        })

        if(red) {
          dispatch(addToFavorite(productz))
          newProducts.push({productId: productz._id})
        }
        
        console.log("Cart id", favorite._id)
        console.log('NEW PRODUCTS', newProducts)
        updateFavorite({_id: favorite._id, products: newProducts}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        })
        .then(res => {
          console.log("res.data", res.data)
          toast.success('Product added to favorites')
        })
        .catch(err => console.log("err", err))   
    } else {
      toast.error("Please log in or register", {
        position: "bottom-left",
    })
    }
  }

  const [title, setTitle] = useState(product.title)

  const handleAddToCart = (product) => {
    if(user?.accessToken && cart?._id) {
      dispatch(addToCart(product))
      const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
      let newProducts = []
      currentProducts.map(product => {
        newProducts.push({productId: product._id, quantity: product.cartQuantity})
      })
      console.log("Cart id", cart._id)
      updateCart({_id: cart._id, products: newProducts}, { 
        headers: {
          'Token': `Bearer ${user?.accessToken}`
        }
      })
      .then(res => toast.success('Product added to cart'))
      .catch(err => console.log("err", err))
    } else {
      console.log("SHOWING ERROR")
      toast.error("Please log in or register", {
        position: "bottom-left",
    })
    }
  }


  const renderMobileProduct = () => (
    <MobileContainer>
    {cartIsLoading && !user && !cartError ? (
          <></>
      ) :
      <>
          <Image cloudName="deqqgmfxk"  publicId={product.img} style={{width: '140px', height: '140px', objectFit:'cover', objectPosition:'center', marginBottom: '15px'}}/>
          <div style={{display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
            <Typography gutterBottom variant="subtitle1" component="h6" style={{textAlign: 'center'}}>
                {product.title}
            </Typography>
            <Typography gutterBottom variant="subtitle1" component="h6">
                ${product.price}
            </Typography>
            <Button variant="contained"className="addToCartBtn" size="small" style={{width: '125px'}}  onClick={() => handleAddToCart(product)}>Add To Cart</Button>
        </div>
      </>
  }
    </MobileContainer>
  )


      const renderTabletProduct = () => (
        <TabletContainer>
        {cartIsLoading && !user && !cartError ? (
              <></>
          ) :
          <>
            <Image cloudName="deqqgmfxk"  publicId={product.img} style={{width: '250px', height: '250px', objectFit:'cover', objectPosition:'center'}}/>
            <div style={{display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center', padding: '10px', width: '200px'}} onClick={() => navigate(`/allItems/${product._id}`)}>
            <Typography gutterBottom variant="h5" component="h2" style={{textAlign: 'center'}}>
                {product.title}
            </Typography>
            <Typography gutterBottom variant="h5" component="h2">
                ${product.price}
            </Typography>
            </div>
          <Info>
            <Icon aria-label="Add to Cart" onClick={() => 
            {
              handleAddToCart(product);
            }}>
              <AddShoppingCart/>
            </Icon>
          </Info>
          </>
      }
        </TabletContainer>
      )
    
      const renderDesktopProduct = () => (
        <Container className="bsd">
        {cartIsLoading && !user && !cartError ? (
              <></>
          ) :
          <>
          <div style={{position:'absolute', right:'2px', top:'0px', backgroundColor:'transparent'}}>
          <Icon color={red ? "primary" : "#000"} style={{width:'40px', height:'40px',backgroundColor:'#efefef'}} onClick={() => handleAddToFavorites(product)}aria-label="Edit product">
            <FavoriteBorderIcon color={red ? 'primary' : ""}/>
          </Icon>
          </div>
          <div id="prodHover" onClick={() => navigate(`/allItems/${product._id}`)}>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Image cloudName="deqqgmfxk"  publicId={product.img} style={{width: '175px', borderRadius: '10px', textAlign: 'center', height: '175px', objectFit:'cover', objectPosition:'center', margin: '0 auto'}}/>
          </div>
            
          <Typography gutterBottom variant="subtitle1" component="h6">
              {title?.substring(0, 35)}
          </Typography>
          <Typography gutterBottom variant="subtitle1" component="h6">
              ${product.price}
          </Typography>
          {(product.quantity <= 5 && product.quantity >=1) && <Chip style={{color: '#fff', backgroundColor: 'red', marginBottom: '5px'}} label={`${product.quantity} left`} />}
          {(product.quantity > 5) && <Chip style={{color: '#fff', backgroundColor: 'green', marginBottom: '5px'}} label={`5+ stock`} />}
          {(product.quantity === 0) && <Chip style={{color: '#fff', backgroundColor: '#eee', marginBottom: '5px'}} label={`0 left`} />}
          </div>

            <Button disabled={product.quantity === 0} variant="outlined" onClick={() => {
                handleAddToCart(product)
            }}>Add to cart</Button>
          </>
      }
        </Container>
      )

    return (
        <div>
            {
                (isXs) ?  renderMobileProduct() : 
                (isSm) ? renderMobileProduct() :
                (isMd) ? renderTabletProduct() :
                renderDesktopProduct()
            }
    </div>
    )
}

export default PopularProduct